import { useEffect, useState } from 'react';
import { useUser } from '@/data/User';
// eslint-disable-next-line no-restricted-imports
import { getContractIdFromContext } from '@/utils/getContractIdFromContext';

export const useContractByUserContext = () => {
	const { user } = useUser();
	const [contract, setContract] = useState<string>(getContractIdFromContext(user?.context));

	useEffect(() => {
		const _contract = getContractIdFromContext(user?.context);
		if (contract !== _contract) {
			setContract(_contract);
		}
	}, [user?.context]); // eslint-disable-line react-hooks/exhaustive-deps

	return contract;
};
